export class UploadRecoveryKeyRequest {
  encryptedUserKey: string;

  constructor(encryptedUserKey: string) {
    this.encryptedUserKey = encryptedUserKey;
  }
}
